import * as qs from 'qs'
import { parseLocationSlug } from '~/composables/transactionalPage/useLocationSlugParser'

const LOCATION_TYPE_TO_STORE_RESOURCE: Partial<
  Record<'region' | 'state' | 'neighborhood', string>
> = {
  region: 'regions',
}

export const eventListPageLocalityCategoriesUrl = () => {
  const params = qs.stringify({
    filter: 'id;permalink;title;slug;avg_review;total_reviews',
    search: 'featured:1',
    limit: '-1',
  })

  return `v1/store/locality-category?${params}`
}

export const eventListPageCategoryUrl = (opts: { categorySlug?: string }) => {
  const params = qs.stringify({
    include: 'thumbnail',
    filter: 'name;slug;thumbnail;avg_review;total_reviews',
  })

  return `/v1/store/categories${
    opts.categorySlug ? `/${opts.categorySlug}` : ''
  }?${params}`
}
export const eventListPageTagUrl = (opts: { tagSlug?: string }) => {
  const params = qs.stringify({
    filter: 'name;slug;avg_review;total_reviews',
  })

  return `/v1/store/tags/${opts.tagSlug}?${params}`
}

export const eventListPageLocalitiesUrl = (opts: {
  locationSlug: string | undefined
}) => {
  const params = qs.stringify({
    filter: 'name;slug;avg_review;total_reviews',
    featured: 1,
  })

  if (!opts.locationSlug) {
    return `v1/store/localities?${params}`
  }

  const parsed = parseLocationSlug(opts.locationSlug)
  if (!parsed.isCity) {
    const resource = LOCATION_TYPE_TO_STORE_RESOURCE[parsed.locationType]
    if (resource) {
      return `v1/store/${resource}/${parsed.readableName}?${params}`
    }
  }

  return `v1/store/localities/${opts.locationSlug}?${params}`
}
